module.exports = {"450329100":"资源镇","450329101":"中峰镇","450329102":"梅溪镇","450329202":"瓜里乡","450329203":"车田苗族乡","450329204":"两水苗族乡","450329205":"河口瑶族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/450329.json
// module id = 1931
// module chunks = 0